module.exports = __webpack_public_path__ + "static/media/PA.da5f03a8.svg";